import './home.css'
import wwwwoohooo from './assets/home/wwwwoohooo.png'

import rankytanktitle from './assets/home/rankytanktitle.png'

import rankytanklogo from './assets/home/wwwrankytank30pct.png'

import wwwappstore15pct from './assets/home/wwwappstore15pct.png'
import wwwgoogleplay15pct from './assets/home/wwwgoogleplay15pct.png'
import privacybutton from './assets/home/privacybutton.png'
import feedbackbutton from './assets/home/feedbackbutton.png'
import dashboardbutton from './assets/home/dashboardbutton.png'
import reportingbutton from './assets/home/reportingbutton.png'
import supportbutton from './assets/home/supportbutton.png'
import Footer from './footer'

function RankyTank() {
  return (
    <div className="page">
      <div className="main_page">
        <a href="/">
          <img className="woohooologo" src={wwwwoohooo} />
        </a>
      </div>

      <div className="main_page" style={{ paddingBottom: 10, display: 'flex' }}>
        <div className="rankytank" style={{ flex: 1, marginTop: '1vw' }}>
          <img className="rankytanktitle2" src={rankytanktitle} />
          <div className="rankytanksubtitle">..for handling statistics for table soccer, padel, tennis, badminton and ping pong.</div>
          <img className="rankytanklogo" src={rankytanklogo} />
          <div>
            <div>
              <div className="rankytankapplestore">
                <a href="https://apps.apple.com/us/app/rankytank/id1642592019">
                  <img src={wwwappstore15pct} />
                </a>
              </div>
              <div className="rankytankgoogleplay">
                <a href="https://play.google.com/store/apps/details?id=com.rankytank2">
                  <img src={wwwgoogleplay15pct} />
                </a>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ display: 'flex', gap: 5, flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ display: 'flex', gap: 5 }}>
                  <div style={{}}>
                    <a href="/privacy">
                      <img src={privacybutton} />
                    </a>
                  </div>
                  <div style={{}}>
                    <a href="/reporting">
                      <img src={reportingbutton} />
                    </a>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 5 }}>
                  <div style={{}}>
                    <a href="/dashboard">
                      <img src={dashboardbutton} />
                    </a>
                  </div>
                  <div style={{}}>
                    <a href="/feedback">
                      <img src={feedbackbutton} />
                    </a>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 5 }}>
                  <div style={{}}>
                    <a href="/support">
                      <img src={supportbutton} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default RankyTank
